import defaultConfig from "config/default"

const { jssdkUrl } = defaultConfig

let _IOS_CONFIG_URL = ''

export function setIOSConfigUrl() {
    _IOS_CONFIG_URL = window.location.href.split('#')[0]
}

export function getWechatConfigUrl() {
    if (isSafari()) {
        return _IOS_CONFIG_URL
    } else {
        return window.location.href
    }
}

export function isSafari() {
    return !!window.__wxjs_is_wkwebview
}

export async function getJSSDKConfig() {
    const uri = encodeURIComponent(getWechatConfigUrl())
    const url = jssdkUrl + uri
    return await fetch(url, {
        method: 'get',
        mode: 'cors',
    }).then(response => {
        return response.json()
    })
}